import { Button } from "../../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { SearchBar } from "../../../components/generic/SearchBar";
import { useEffect, useState } from "react";
 
 import { useDeptHook } from "../../../hooks/useDeptHook";
 import { NoEmployee } from "../../../components/users/NoEmployee";
import AddEmployee from "../../../components/Modules/Employees/AddEmployee";
import EmployeeItem from "./EmployeeItem";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import usePositionHook from "../../../hooks/usePositionHook";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import EmployeeDetailed from "./EmployeeDetailed";

const Employees = () => {
  const departmentPicked = usePickerhook();
  const positionPicked = usePickerhook();
  
  const [showadddept, setshowadddept] = useState(false);
  const { selectedOrgEmployees, refresh } = useEmployeeHook();
const  [renderedlist, setrenderedlist] =useState(selectedOrgEmployees)


  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();
  const { authuser } = useStateGetter();
  const { setselectedEmpl, setSidebarRenderView } = useStateSetter();
  const [entered, setentered] = useState("");

  const onChange = (e: string) => {
    setentered(e);
  };


  useEffect(()=>{
setrenderedlist(selectedOrgEmployees)


  },[selectedOrgEmployees])

useEffect(()=>{

setrenderedlist(selectedOrgEmployees.filter((t)=>t.deptID==departmentPicked.pickedRole.code))

},[departmentPicked.pickedRole])

useEffect(()=>{

setrenderedlist(selectedOrgEmployees.filter((t)=>t.positionID==positionPicked.pickedRole.code))

},[positionPicked.pickedRole])

  useEffect(() => {
    if (authuser.isEmployee) {
      
      selectedOrgEmployees.map((it: any) => {
        if (it.workEmail == authuser.email) {
            setSidebarRenderView(<EmployeeDetailed id={it.id} />);
        }
      });
    }
  }, [selectedOrgEmployees]);

  return (
    <div className="w-full pr-20  flex  ">
      {showadddept && <AddEmployee refresh={refresh} show={setshowadddept} />}
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Employees({selectedOrgEmployees.length})
          </p>

          <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add Employee
              </>
            }
            onBtnClick={() => {
              setshowadddept(true);
            }}
          />
        </div>
        <div className="w-full flex justify-between items-center">
          
          <div className="flex  gap-2">
            <ListPicker
              hook={departmentPicked}
              notitle
              title="Department"
              list={
                selectedOrgDepts
                  ? selectedOrgDepts?.map((i) => {
                      return { name: i.deptName, code: i.id };
                    })
                  : []
              }
            />
            <ListPicker
              hook={positionPicked}
              notitle
              title="Position"
              list={
                allorgPositions
                  ? allorgPositions?.map((i: any) => {
                      return { name: i.positionTitle, code: i.id };
                    })
                  : []
              }
            />
          </div>
          <SearchBar
            placeholder="Search Contract"
            onchange={onChange}
            value={entered}
          />
        </div>
        <hr />

        {selectedOrgEmployees.length > 0 ? (
          <div className=" grid grid-cols-2 gap-4 py-4">
            {renderedlist.map((i: any) => (
              <EmployeeItem item={i} />
            ))}
          </div>
        ) : (
          <div className="flex justify-center items-center">
            <NoEmployee add={setshowadddept} />
          </div>
        )}
      </div>
    </div>
  );
};
export { Employees };
